import ProductDescription from './index';
import Error from '../../components/ErrorBoundary';

const ProductSlug = () => {
  return <ProductDescription />;
};

export default ProductSlug;

export const ErrorBoundary = () => {
  return <Error fromPage="Product Description Page" />;
};
